import React from "react";

const flexPointPayToday = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		version="1.1"
		id="Layer_1"
		x="0px"
		y="0px"
		width="122px"
		height="71.3px"
		viewBox="0 0 122 71.3"
		xmlSpace="preserve"
	>
		<g>
			<g>
				<path
					fill="#FFFFFF"
					d="M95.7,47.9c-0.5,1.6-2.2,3.2-3.8,3.5L17,67.4c-1.6,0.3-3.2-0.7-3.6-2.3L4.3,22.6C4,20.9,5,19.3,6.7,19L81.6,3    c1.6-0.3,3.8,0.4,4.9,1.6l14.5,16.8c1.1,1.3,1.6,3.6,1.1,5.1L95.7,47.9z"
				/>
			</g>
			<g>
				<path
					fill="#150E2F"
					d="M16.4,68.5c-1.8,0-3.5-1.3-3.9-3.2L3.4,22.8c-0.2-1,0-2.1,0.6-3c0.6-0.9,1.5-1.5,2.5-1.7L81.4,2    c2-0.4,4.5,0.4,5.9,2l14.5,16.8c1.3,1.5,1.9,4.2,1.3,6.1l-6.3,21.3c-0.6,1.9-2.6,3.8-4.5,4.2l-74.9,16    C16.9,68.5,16.7,68.5,16.4,68.5z M82.4,3.9c-0.2,0-0.4,0-0.6,0.1L6.9,20c-0.5,0.1-1,0.4-1.3,0.9c-0.3,0.5-0.4,1-0.3,1.5l9.1,42.6    c0.2,1.1,1.3,1.8,2.4,1.5l74.9-16c1.3-0.3,2.7-1.6,3-2.8l6.3-21.3c0.4-1.3,0-3.2-0.9-4.2L85.7,5.3C85,4.5,83.6,3.9,82.4,3.9z"
				/>
			</g>
		</g>
		<g>
			<path
				fill="#1F1949"
				d="M26.5,46.7l-2.8-13c-1.1-5.3,1.6-9.4,6.9-10.5s9.5,1.5,10.6,6.8l2.8,13c1.1,5.3-1.6,9.4-6.9,10.6   S27.6,52,26.5,46.7z M39.2,44.3l-2.9-13.5c-0.5-2.6-2.5-3.9-4.8-3.4c-2.3,0.5-3.5,2.5-2.9,5l2.9,13.5c0.5,2.5,2.4,3.8,4.7,3.3   C38.5,48.8,39.7,46.8,39.2,44.3z"
			/>
			<path
				fill="#1F1949"
				d="M53.5,49.1l-6.1-28.6c-0.1-0.3,0.1-0.5,0.3-0.5l2.1-0.5c0.3-0.1,0.5,0.1,0.5,0.3L54,36.9c0,0.1,0.2,0.2,0.2,0   l5.7-10.8c0.1-0.2,0.2-0.3,0.5-0.4l2.4-0.5c0.3-0.1,0.5,0.1,0.4,0.5l-3.5,7c0,0.1-0.1,0.1,0,0.2l8.7,12.9c0.1,0.1,0.1,0.1,0.1,0.2   c0,0.2-0.1,0.4-0.3,0.4l-2.3,0.5c-0.2,0-0.4,0-0.5-0.2l-7.2-11c-0.1-0.1-0.2-0.1-0.3,0L55,41.1c0,0.1-0.1,0.1,0,0.2l1.5,7.1   c0.1,0.3-0.1,0.5-0.3,0.5L54,49.4C53.8,49.5,53.6,49.3,53.5,49.1z"
			/>
			<path
				fill="#1F1949"
				d="M78.5,22.3c0.2,0,0.3,0.2,0.3,0.5l0,2.3c0,0.3-0.2,0.4-0.4,0.4c-0.5-0.1-1.2-0.1-2,0.2   c-2.5,0.6-3.7,3.3-3.1,6.3l2.7,12.5c0.1,0.3-0.1,0.5-0.3,0.5l-2.1,0.5c-0.3,0.1-0.5-0.1-0.5-0.3l-4.4-20.4   c-0.1-0.3,0.1-0.5,0.3-0.5l2.1-0.5c0.3-0.1,0.5,0.1,0.5,0.3l0.6,2.6c0,0.2,0.2,0.1,0.2,0c0.5-2.2,1.8-3.9,4-4.3   C77.2,22,77.9,22.1,78.5,22.3z"
			/>
		</g>
		<g>
			<path
				fill="#150E2F"
				d="M93.5,31.4c-2.8,0-5.2-2.3-5.2-5.2c0-2.8,2.3-5.2,5.2-5.2c2.8,0,5.2,2.3,5.2,5.2   C98.7,29.1,96.4,31.4,93.5,31.4z M93.5,21.9c-2.4,0-4.4,2-4.4,4.4c0,2.4,2,4.4,4.4,4.4s4.4-2,4.4-4.4   C97.9,23.9,95.9,21.9,93.5,21.9z"
			/>
		</g>
		<g>
			<path
				fill="#F7B912"
				d="M116.9,9.5c-3.1-3.2-7.8-4.6-11.9-5.9c-0.9-0.3-1.3,1.2-0.4,1.4c3.6,1.2,7.6,2.4,10.5,4.9c2.7,2.3,4,6.1,3,9.6   c-0.9,3.3-4.3,4.8-7.4,5.5c-3.6,0.8-7.2,0.4-10.8-0.2c-3.7-0.7-8-0.5-10.7,2.4c0.1,0.6,0.4,1.1,0.7,1.5c2.7-4,8.1-2.6,12.1-2   c3.7,0.5,7.6,0.4,11.1-0.8c3.1-1,6-3.2,6.6-6.5C120.4,15.9,119.5,12.1,116.9,9.5z"
			/>
			<path
				fill="#150E2F"
				d="M89.2,26.3c0-1.7,1-3.2,2.4-3.9l-0.4-0.7c-1.7,0.9-2.8,2.6-2.8,4.6c0,0.6,0.1,1.2,0.3,1.7   c0.2-0.3,0.4-0.5,0.6-0.8C89.2,26.9,89.2,26.6,89.2,26.3z"
			/>
			<path
				fill="#150E2F"
				d="M89.2,29.2c0.9,1.4,2.5,2.3,4.3,2.3c1.1,0,2.2-0.4,3-1l-0.4-0.7c-0.7,0.6-1.6,0.9-2.6,0.9   c-1.5,0-2.8-0.7-3.6-1.9c0,0,0,0-0.1,0.1C89.7,29.1,89.5,29.2,89.2,29.2z"
			/>
			<path
				fill="#150E2F"
				d="M88.7,28c0.1,0.4,0.3,0.8,0.6,1.2c0.2,0,0.5-0.1,0.7-0.3c0,0,0,0,0.1-0.1c-0.3-0.5-0.5-1-0.7-1.5   C89.1,27.5,88.9,27.7,88.7,28z"
			/>
		</g>
	</svg>
);

const flexPointFreeReturn = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		version="1.1"
		id="Layer_2"
		x="0px"
		y="0px"
		width="115.1px"
		height="84.2px"
		viewBox="0 0 115.1 84.2"
		xmlSpace="preserve"
	>
		<path
			fill="#150E2F"
			d="M21,39.2H1c-0.6,0-1,0.4-1,1v20c0,0.6,0.4,1,1,1h20c0.6,0,1-0.4,1-1v-20C22,39.7,21.6,39.2,21,39.2z M8.1,40.2  H14v5.4H8.1V40.2z M21,60.3H1v-20h6.6v5.9h6.9v-5.9H21V60.3z"
		/>
		<path
			fill="#150E2F"
			d="M114.1,39.2H94c-0.6,0-1,0.4-1,1v20c0,0.6,0.4,1,1,1h20c0.6,0,1-0.4,1-1v-20C115.1,39.7,114.6,39.2,114.1,39.2z   M101.1,40.2h5.9v5.4h-5.9V40.2z M114.1,60.3H94v-20h6.6v5.9h6.9v-5.9h6.6V60.3z"
		/>
		<path
			fill="#150E2F"
			d="M21,0H1C0.4,0,0,0.4,0,1v19c0,0.6,0.4,1,1,1h20c0.6,0,1-0.4,1-1V1C22,0.4,21.6,0,21,0z M8.1,1H14v5.1H8.1V1z   M21,20H1V1h6.6v5.6h6.9V1H21V20z"
		/>
		<path
			fill="#150E2F"
			d="M67.6,0h-20c-0.6,0-1,0.4-1,1v20c0,0.6,0.4,1,1,1h20c0.6,0,1-0.4,1-1V1C68.6,0.5,68.1,0,67.6,0z M54.6,1h5.9  v5.4h-5.9V1z M67.6,21.1h-20V1h6.6v5.9H61V1h6.6V21.1z"
		/>
		<path
			fill="#150E2F"
			d="M114.1,0H94c-0.6,0-1,0.4-1,1v20c0,0.6,0.4,1,1,1h20c0.6,0,1-0.4,1-1V1C115.1,0.5,114.6,0,114.1,0z M101.1,1  h5.9v5.4h-5.9V1z M114.1,21.1H94V1h6.6v5.9h6.9V1h6.6V21.1z"
		/>
		<g>
			<path
				fill="#F7B912"
				d="M49.9,31.7V38c0,0.3-0.2,0.5-0.5,0.6l-6.8,0.9c-0.3,0-0.5-0.2-0.5-0.4v-5.3"
			/>
		</g>
		<g>
			<path
				fill="#F7B912"
				d="M65.5,32.2V38c0,0.3,0.2,0.5,0.5,0.6l6.8,0.9c0.3,0,0.5-0.2,0.5-0.4v-5.3"
			/>
		</g>
		<polygon
			fill="#1F1949"
			points="89.6,69.2 68.4,50.4 66.6,78.8 74.9,72.2 79.8,84.2 84.1,82.4 79.1,70.4 "
		/>
		<path
			fill="#150E2F"
			d="M80.8,33.6L58.4,29c-0.4-0.1-1-0.1-1.3,0l-22.4,4.7c-0.7,0.1-1.2,0.8-1.2,1.5v31.2c0,0.7,0.5,1.3,1.2,1.5  L57,72.4c0.2,0,0.4,0.1,0.7,0.1c0.2,0,0.5,0,0.7-0.1l6.7-1.4l0.1-1.9l-6.9,1.4V30.8l6.9,1.4V38c0,0.4,0.3,0.8,0.7,0.8l6.8,0.9  c0,0,0.1,0,0.1,0c0.2,0,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5v-5l6.6,1.4v22.8l1.8,1.6V35.1C82,34.4,81.4,33.8,80.8,33.6z   M42.3,33.9l7.3-1.5V38c0,0.1-0.1,0.3-0.3,0.3l-6.8,0.9c-0.1,0-0.1,0-0.2,0c0,0-0.1-0.1-0.1-0.1V33.9z M35.2,66.1V35.4l6.6-1.4v5  c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2c0,0,0.1,0,0.1,0l6.8-0.9c0.4,0,0.7-0.4,0.7-0.8v-5.8l6.9-1.4v39.8L35.2,66.1z   M73,39c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0-0.2,0L66,38.3c-0.1,0-0.3-0.2-0.3-0.3v-5.7l7.3,1.5V39z"
		/>
		<path
			fill="#F7B912"
			d="M76.6,49.5c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l2.9-2.9c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-2.9,2.9  C77.1,49.4,76.8,49.5,76.6,49.5z"
		/>
		<path
			fill="#F7B912"
			d="M70.5,48c-0.6,0-1-0.4-1-1v-4.4c0-0.6,0.4-1,1-1s1,0.4,1,1V47C71.5,47.6,71.1,48,70.5,48z"
		/>
		<path
			fill="#F7B912"
			d="M64.4,48.9c-0.3,0-0.5-0.1-0.7-0.3l-2.9-2.9c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l2.9,2.9c0.4,0.4,0.4,1,0,1.4  C64.9,48.8,64.7,48.9,64.4,48.9z"
		/>
		<path
			fill="#F7B912"
			d="M61.6,54.8h-4.1c-0.6,0-1-0.4-1-1s0.4-1,1-1h4.1c0.6,0,1,0.4,1,1S62.1,54.8,61.6,54.8z"
		/>
		<path
			fill="#F7B912"
			d="M60.9,63.9c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l2.9-2.9c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-2.9,2.9  C61.4,63.8,61.1,63.9,60.9,63.9z"
		/>
		<path
			fill="#F7B912"
			d="M82.8,55.7h-4.1c-0.6,0-1-0.4-1-1s0.4-1,1-1h4.1c0.6,0,1,0.4,1,1S83.4,55.7,82.8,55.7z"
		/>
	</svg>
);

const flexPointNewOwner = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		version="1.1"
		x="0px"
		y="0px"
		width="84.6px"
		height="76.3px"
		viewBox="0 0 84.6 76.3"
	>
		<g id="Layer_1_copy">
			<g>
				<g>
					<path
						fill="#F7B912"
						d="M36.1,20v5.3c0,0.3-0.2,0.5-0.5,0.6l-5.4,0.7c-0.3,0-0.5-0.2-0.5-0.4v-4.3"
					/>
				</g>
				<g>
					<path
						fill="#150E2F"
						d="M30.2,26.8c-0.2,0-0.3-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5v-4.5H30v4.5c0,0.1,0,0.1,0.1,0.1     c0,0,0.1,0.1,0.2,0l5.4-0.7c0.1,0,0.3-0.2,0.3-0.3v-5.6h0.5v5.6c0,0.4-0.3,0.8-0.7,0.8L30.2,26.8C30.2,26.8,30.2,26.8,30.2,26.8z     "
					/>
				</g>
			</g>
			<g>
				<g>
					<path
						fill="#F7B912"
						d="M48.9,20.6v4.7c0,0.3,0.2,0.5,0.5,0.6l5.4,0.7c0.3,0,0.5-0.2,0.5-0.4v-4.3"
					/>
				</g>
				<g>
					<path
						fill="#150E2F"
						d="M54.9,26.8C54.8,26.8,54.8,26.8,54.9,26.8l-5.5-0.7c-0.4,0-0.7-0.4-0.7-0.8v-4.9h0.5v4.9     c0,0.1,0.1,0.3,0.3,0.3l5.4,0.7c0.1,0,0.1,0,0.2,0c0,0,0.1-0.1,0.1-0.1v-4.5h0.5v4.5c0,0.2-0.1,0.4-0.2,0.5     C55.2,26.7,55,26.8,54.9,26.8z"
					/>
				</g>
			</g>
			<path
				fill="#150E2F"
				d="M61.3,21.8L43.2,18c-0.4-0.1-0.9-0.1-1.3,0l-18.2,3.8c-0.6,0.1-1.1,0.7-1.1,1.3v25.3c0,0.6,0.5,1.2,1.1,1.3   l18.2,3.8c0.2,0,0.4,0.1,0.6,0.1c0.2,0,0.5,0,0.6-0.1l18.2-3.8c0.6-0.1,1.1-0.7,1.1-1.3V23.1C62.4,22.5,62,21.9,61.3,21.8z    M24.1,48.3V23.2l17.8-3.7v32.5L24.1,48.3z M60.9,48.3l-17.8,3.7V19.5l17.8,3.7V48.3z"
			/>
			<g>
				<path
					fill="#150E2F"
					d="M82.5,34.5c2.1-5.3,4-14-1.7-22.6C76.5,5.2,68.5,1,60.9,1h0v2.3c7,0,14.2,3.9,18.1,9.8    c2.3,3.5,3.4,7.3,3.4,11.3c0,3-0.7,6.1-1.9,9.2C79.8,35,77.1,39.1,65.3,51c-2,2-4.1,4.1-6.2,6.2l0.6-3c0-0.1,0-0.3-0.1-0.4    l-1.4-1.4c-0.1-0.1-0.3-0.1-0.4,0.1l-1.1,6.8c0,0.1,0,0.3,0.1,0.4l1.3,1.3c0.1,0.1,0.2,0.1,0.4,0.1l6.8-1.1    c0.2-0.1,0.2-0.2,0.1-0.4l-1.4-1.4c-0.1-0.1-0.2-0.1-0.4-0.1l-3.2,0.7C70.4,49.2,81.1,38.2,82.5,34.5z"
				/>
				<path
					fill="#150E2F"
					d="M58.5,1.2C48.9,2.3,45,7.3,42.3,10.9c-2.7-3.6-6.6-8.6-16.2-9.8C25.3,1.1,24.6,1,23.8,1    c-1.1,0-2.2,0.1-3.4,0.3l0.7,2.2c0.9-0.1,1.8-0.2,2.7-0.2c0.7,0,1.4,0,2.1,0.1c8.9,1.1,12.3,5.7,14.6,8.8l1.8,2.5l1.8-2.5    c2.3-3.1,5.7-7.8,14.6-8.8c0.7-0.1,1.4-0.1,2.1-0.1l0-2.3c0,0,0,0,0,0C60.1,1,59.3,1.1,58.5,1.2z"
				/>
			</g>
			<path
				fill="#150E2F"
				d="M54.5,61.6c-4.1,3.9-7.9,7.5-10.7,10.1c-0.5,0.5-1.1,1-1.5,1.4c-0.5-0.4-1-0.9-1.5-1.4   C35.6,66.8,27,58.7,19.3,51C7.5,39.1,4.8,35,4.2,33.6c-1.3-3.1-1.9-6.3-1.9-9.2c0-4,1.1-7.8,3.4-11.3c2.1-3.3,5.4-5.9,9-7.6   l-1.9,2.3c-0.1,0.1-0.1,0.2-0.1,0.4l0.6,1.9c0.1,0.2,0.2,0.2,0.4,0.1l4.1-5.6c0.1-0.1,0.1-0.2,0.1-0.4l-0.6-1.7   c0-0.1-0.1-0.2-0.3-0.2L10.4,0c-0.2,0-0.3,0.1-0.2,0.3l0.6,1.9c0,0.1,0.1,0.2,0.3,0.2l3,0.8C9.9,5.1,6.3,8,3.8,11.8   C-1.9,20.5,0,29.2,2.1,34.5c2.9,7.2,40,41.6,40,41.6l0.2,0.2l0.2-0.2c0,0,6.1-5.7,13.6-12.9L54.5,61.6z"
			/>
		</g>
	</svg>
);

const flexPointReplaceAfter = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		version="1.1"
		id="flexPointNewOwnerId"
		x="0px"
		y="0px"
		width="68.7px"
		height="76px"
		viewBox="0 0 68.7 76"
	>
		<g>
			<path
				fill="#150E2F"
				d="M58.1,71.6c0,2.9-2,4.4-4.6,4.4H19.1c-2.5,0-4.6-1.5-4.6-4.4V14.4c0-2.9,2-4.4,4.6-4.4h34.4   c2.5,0,4.6,1.4,4.6,4.4V71.6z"
			/>
			<path
				fill="#FFFFFF"
				d="M57.1,69.9c0,5-1.9,5-4.3,5h-33c-2.4,0-4.4-0.9-4.3-5V16.1c0.1-4.4,1.9-5,4.3-5h33c2.4,0,4.3,0,4.3,5V69.9z"
			/>
		</g>
		<g>
			<g>
				<path
					fill="#FFFFFF"
					d="M20.4,59c0,1.6-1.1,2.9-2.5,2.9h-15c-1.4,0-2.5-1.3-2.5-2.9V25.7c0-1.6,1.1-2.9,2.5-2.9h15    c1.4,0,2.5,1.3,2.5,2.9V59z"
				/>
				<path
					fill="#150E2F"
					d="M17.9,62.3h-15C1.3,62.3,0,60.8,0,59V25.7c0-1.8,1.3-3.3,2.8-3.3h15c1.6,0,2.8,1.5,2.8,3.3V59    C20.7,60.8,19.4,62.3,17.9,62.3z M2.8,23.1c-1.2,0-2.2,1.2-2.2,2.6V59c0,1.4,1,2.6,2.2,2.6h15c1.2,0,2.2-1.2,2.2-2.6V25.7    c0-1.4-1-2.6-2.2-2.6H2.8z"
				/>
			</g>
			<g>
				<rect x="1.9" y="25.9" fill="#FFFFFF" width="17" height="31.2" />
				<path
					fill="#150E2F"
					d="M19.2,57.5H1.5V25.6h17.7V57.5z M2.2,56.8h16.3V26.3H2.2V56.8z"
				/>
			</g>
			<path
				fill="#150E2F"
				d="M13,24.2c0,0.2-0.2,0.3-0.4,0.3H8c-0.2,0-0.4-0.1-0.4-0.3l0,0c0-0.2,0.2-0.3,0.4-0.3h4.6   C12.9,23.9,13,24.1,13,24.2L13,24.2z"
			/>
		</g>
		<g>
			<path
				fill="#150E2F"
				d="M10.6,60.8c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4   C12.1,60.1,11.4,60.8,10.6,60.8z M10.6,58.4c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9   C11.6,58.9,11.2,58.4,10.6,58.4z"
			/>
		</g>
		<path
			fill="#F7B912"
			d="M68.2,16.7h-6c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h6c0.3,0,0.5,0.2,0.5,0.5  C68.7,16.5,68.5,16.7,68.2,16.7z"
		/>
		<path
			fill="#F7B912"
			d="M60,9.5c-0.1,0-0.3,0-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.7l4.3-4.3c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7  l-4.3,4.3C60.2,9.4,60.1,9.5,60,9.5z"
		/>
		<path
			fill="#F7B912"
			d="M53.4,7c-0.3,0-0.5-0.2-0.5-0.5v-6c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v6C53.9,6.8,53.6,7,53.4,7z"
		/>
		<g>
			<g>
				<path
					fill="#150E2F"
					d="M45.4,30.9l-7.8,10.6l0,0.1l0,0l-3.6,0l0-0.1l0-0.1l-7.8-10.6l3.3,0l0,0l0,0l5.5,8.5c0.2,0.4,0.6,0.5,0.8,0.5    c0.2,0,0.5,0,0.8-0.5l5.5-8.5l0-0.1l0,0H45.4 M46,30.2h-3.9c-0.3,0-0.5,0.1-0.6,0.4l-5.6,8.6c0,0.1-0.1,0.1-0.1,0.1    c0,0-0.1,0-0.1-0.1l-5.5-8.6c-0.1-0.3-0.4-0.4-0.6-0.4h-3.9c-0.4,0-0.6,0.3-0.4,0.6L33.4,42c0.1,0.3,0.4,0.4,0.6,0.4h3.6    c0.3,0,0.5-0.1,0.6-0.4l8.2-11.1C46.6,30.5,46.4,30.2,46,30.2L46,30.2z"
				/>
			</g>
		</g>
		<g>
			<g>
				<path
					fill="#150E2F"
					d="M25.2,55.6l8.2-11.1c0.1-0.3,0.4-0.4,0.6-0.4h3.6c0.3,0,0.5,0.1,0.6,0.4l8.2,11.1c0.2,0.4,0,0.6-0.4,0.6h-3.9    c-0.3,0-0.5-0.1-0.6-0.4l-5.5-8.6c-0.1-0.2-0.2-0.2-0.3,0l-5.6,8.6c-0.1,0.3-0.4,0.4-0.6,0.4h-3.9C25.2,56.3,25,56,25.2,55.6z"
				/>
			</g>
		</g>
		<path
			fill="#1F1949"
			d="M4.5,35c0,0-0.1,0-0.1-0.1c0-0.1,0-0.1,0-0.2l7.2-4.2c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2L4.5,35  C4.6,35,4.5,35,4.5,35z"
		/>
		<path
			fill="#1F1949"
			d="M7,38.1c0,0-0.1,0-0.1-0.1c0-0.1,0-0.1,0-0.2l7.2-4.2c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2L7,38.1  C7,38.1,7,38.1,7,38.1z"
		/>
		<path
			fill="#1F1949"
			d="M4.4,37.6c0,0-0.1,0-0.1-0.1c0-0.1,0-0.1,0-0.2l10.2-5.9c0.1,0,0.1,0,0.2,0c0,0.1,0,0.1,0,0.2L4.4,37.6  C4.4,37.6,4.4,37.6,4.4,37.6z"
		/>
		<path
			fill="#1F1949"
			d="M24.4,21.9c-0.1,0-0.1,0-0.1-0.1c0-0.1,0-0.2,0.1-0.2l9.5-5.5c0.1,0,0.2,0,0.2,0.1c0,0.1,0,0.2-0.1,0.2  L24.4,21.9C24.4,21.9,24.4,21.9,24.4,21.9z"
		/>
		<path
			fill="#1F1949"
			d="M27.3,25.8c-0.1,0-0.1,0-0.1-0.1c0-0.1,0-0.2,0.1-0.2l9.5-5.5c0.1,0,0.2,0,0.2,0.1c0,0.1,0,0.2-0.1,0.2  L27.3,25.8C27.3,25.8,27.3,25.8,27.3,25.8z"
		/>
		<path
			fill="#1F1949"
			d="M23.8,24.9c-0.1,0-0.1,0-0.1-0.1c0-0.1,0-0.2,0.1-0.2l13.5-7.8c0.1,0,0.2,0,0.2,0.1c0,0.1,0,0.2-0.1,0.2  L23.8,24.9C23.9,24.9,23.8,24.9,23.8,24.9z"
		/>
	</svg>
);

export {
	flexPointFreeReturn,
	flexPointNewOwner,
	flexPointReplaceAfter,
	flexPointPayToday,
};
